// Monday, 02 June 2026
// Change this version if you want to invalidate old data
export const DATA_VERSION = '1748908800';
